// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProseMirror {
  .tableWrapper {
    margin-top: 3rem; /* my-12 */
    margin-bottom: 3rem;
  }

  table {
    border-collapse: collapse;
    border: 1px solid rgba(0, 0, 0, 0.1); /* border-black/10 */
    border-radius: 0.375rem; /* rounded */
    box-sizing: border-box; /* box-border */
    width: 100%; /* w-full */
  }

  td,
  th {
    border: 1px solid rgba(0, 0, 0, 0.1); /* border-black/10 */
    min-width: 100px; /* min-w-[100px] */
    padding: 0.5rem; /* p-2 */
    position: relative;
    text-align: left; /* text-left */
    vertical-align: top; /* align-top */
  }

  td:first-of-type:not(a) {
    margin-top: 0; /* mt-0 */
  }

  td p {
    margin: 0; /* m-0 */
  }

  td p + p {
    margin-top: 0.75rem; /* mt-3 */
  }

  th {
    font-weight: bold; /* font-bold */
  }

  .column-resize-handle {
    bottom: -2px; /* -bottom-[2px] */
    display: flex;
    pointer-events: none; /* pointer-events-none */
    position: absolute;
    right: -1px; /* -right-1 */
    top: 0; /* top-0 */
    width: 0.5rem; /* w-2 */
  }

  .column-resize-handle::before {
    background-color: rgba(0, 0, 0, 0.2); /* bg-black/20 */
    height: 100%; /* h-full */
    width: 1px; /* w-[1px] */
    margin-left: 0.5rem; /* ml-2 */
    content: "";
  }

  .selectedCell {
    background-color: rgba(0, 0, 0, 0.05); /* bg-black/5 */
    border-color: rgba(0, 0, 0, 0.2); /* border-black/20 */
    border-style: double; /* border-double */
  }

  .grip-column,
  .grip-row {
    align-items: center; /* items-center */
    background-color: rgba(0, 0, 0, 0.05); /* bg-black/5 */
    cursor: pointer; /* cursor-pointer */
    display: flex;
    justify-content: center; /* justify-center */
    position: absolute;
    z-index: 10; /* z-10 */
  }

  .grip-column {
    width: calc(100% + 1px); /* w-[calc(100%+1px)] */
    border-left: 1px solid rgba(0, 0, 0, 0.2); /* border-l border-black/20 */
    height: 0.75rem; /* h-3 */
    left: 0; /* left-0 */
    margin-left: -1px; /* -ml-[1px] */
    top: -0.75rem; /* -top-3 */
  }

  .grip-column:hover,
  .grip-column.selected {
    &::before {
      content: "";
      width: 0.625rem; /* w-2.5 */
    }
  }

  .grip-column:hover {
    background-color: rgba(0, 0, 0, 0.1); /* bg-black/10 */
  }

  .grip-column:hover::before {
    border-bottom: 2px solid rgba(0, 0, 0, 0.6); /* border-b-2 border-dotted border-black/60 */
  }

  .grip-column.first {
    border-color: transparent; /* border-transparent */
    border-radius: 0.125rem 0 0 0; /* rounded-tl-sm */
  }

  .grip-column.last {
    border-radius: 0 0.125rem 0 0; /* rounded-tr-sm */
  }

  .grip-column.selected {
    background-color: rgba(0, 0, 0, 0.3); /* bg-black/30 */
    border-color: rgba(0, 0, 0, 0.3); /* border-black/30 */
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15); /* shadow-sm */
  }

  .grip-column.selected::before {
    border-bottom: 2px solid dotted; /* border-b-2 border-dotted */
  }

  .grip-row {
    height: calc(100% + 1px); /* h-[calc(100%+1px)] */
    border-top: 1px solid rgba(0, 0, 0, 0.2); /* border-t border-black/20 */
    left: -0.75rem; /* -left-3 */
    width: 0.75rem; /* w-3 */
    top: 0; /* top-0 */
    margin-top: -1px; /* -mt-[1px] */
  }

  .grip-row:hover,
  .grip-row.selected {
    &::before {
      height: 0.625rem; /* h-2.5 */
      content: "";
    }
  }

  .grip-row:hover {
    background-color: rgba(0, 0, 0, 0.1); /* bg-black/10 */
  }

  .grip-row:hover::before {
    border-left: 2px solid dotted rgba(0, 0, 0, 0.6); /* border-l-2 border-dotted border-black/60 */
  }

  .grip-row.first {
    border-color: transparent; /* border-transparent */
    border-radius: 0.125rem 0 0 0; /* rounded-tl-sm */
  }

  .grip-row.last {
    border-radius: 0 0.125rem 0 0; /* rounded-bl-sm */
  }

  .grip-row.selected {
    background-color: rgba(0, 0, 0, 0.3); /* bg-black/30 */
    border-color: rgba(0, 0, 0, 0.3); /* border-black/30 */
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15); /* shadow-sm */
  }

  .grip-row.selected::before {
    border-left: 2px solid dotted; /* border-l-2 border-dotted */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Reusable/RichTextEditor/src/styles/partials/table.css"],"names":[],"mappings":"AAAA;EACE;IACE,gBAAgB,EAAE,UAAU;IAC5B,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,oCAAoC,EAAE,oBAAoB;IAC1D,uBAAuB,EAAE,YAAY;IACrC,sBAAsB,EAAE,eAAe;IACvC,WAAW,EAAE,WAAW;EAC1B;;EAEA;;IAEE,oCAAoC,EAAE,oBAAoB;IAC1D,gBAAgB,EAAE,kBAAkB;IACpC,eAAe,EAAE,QAAQ;IACzB,kBAAkB;IAClB,gBAAgB,EAAE,cAAc;IAChC,mBAAmB,EAAE,cAAc;EACrC;;EAEA;IACE,aAAa,EAAE,SAAS;EAC1B;;EAEA;IACE,SAAS,EAAE,QAAQ;EACrB;;EAEA;IACE,mBAAmB,EAAE,SAAS;EAChC;;EAEA;IACE,iBAAiB,EAAE,cAAc;EACnC;;EAEA;IACE,YAAY,EAAE,kBAAkB;IAChC,aAAa;IACb,oBAAoB,EAAE,wBAAwB;IAC9C,kBAAkB;IAClB,WAAW,EAAE,aAAa;IAC1B,MAAM,EAAE,UAAU;IAClB,aAAa,EAAE,QAAQ;EACzB;;EAEA;IACE,oCAAoC,EAAE,gBAAgB;IACtD,YAAY,EAAE,WAAW;IACzB,UAAU,EAAE,YAAY;IACxB,mBAAmB,EAAE,SAAS;IAC9B,WAAW;EACb;;EAEA;IACE,qCAAqC,EAAE,eAAe;IACtD,gCAAgC,EAAE,oBAAoB;IACtD,oBAAoB,EAAE,kBAAkB;EAC1C;;EAEA;;IAEE,mBAAmB,EAAE,iBAAiB;IACtC,qCAAqC,EAAE,eAAe;IACtD,eAAe,EAAE,mBAAmB;IACpC,aAAa;IACb,uBAAuB,EAAE,mBAAmB;IAC5C,kBAAkB;IAClB,WAAW,EAAE,SAAS;EACxB;;EAEA;IACE,uBAAuB,EAAE,uBAAuB;IAChD,yCAAyC,EAAE,6BAA6B;IACxE,eAAe,EAAE,QAAQ;IACzB,OAAO,EAAE,WAAW;IACpB,iBAAiB,EAAE,cAAc;IACjC,aAAa,EAAE,WAAW;EAC5B;;EAEA;;IAEE;MACE,WAAW;MACX,eAAe,EAAE,UAAU;IAC7B;EACF;;EAEA;IACE,oCAAoC,EAAE,gBAAgB;EACxD;;EAEA;IACE,2CAA2C,EAAE,6CAA6C;EAC5F;;EAEA;IACE,yBAAyB,EAAE,uBAAuB;IAClD,6BAA6B,EAAE,kBAAkB;EACnD;;EAEA;IACE,6BAA6B,EAAE,kBAAkB;EACnD;;EAEA;IACE,oCAAoC,EAAE,gBAAgB;IACtD,gCAAgC,EAAE,oBAAoB;IACtD,yCAAyC,EAAE,cAAc;EAC3D;;EAEA;IACE,+BAA+B,EAAE,6BAA6B;EAChE;;EAEA;IACE,wBAAwB,EAAE,uBAAuB;IACjD,wCAAwC,EAAE,6BAA6B;IACvE,cAAc,EAAE,YAAY;IAC5B,cAAc,EAAE,QAAQ;IACxB,MAAM,EAAE,UAAU;IAClB,gBAAgB,EAAE,cAAc;EAClC;;EAEA;;IAEE;MACE,gBAAgB,EAAE,UAAU;MAC5B,WAAW;IACb;EACF;;EAEA;IACE,oCAAoC,EAAE,gBAAgB;EACxD;;EAEA;IACE,gDAAgD,EAAE,6CAA6C;EACjG;;EAEA;IACE,yBAAyB,EAAE,uBAAuB;IAClD,6BAA6B,EAAE,kBAAkB;EACnD;;EAEA;IACE,6BAA6B,EAAE,kBAAkB;EACnD;;EAEA;IACE,oCAAoC,EAAE,gBAAgB;IACtD,gCAAgC,EAAE,oBAAoB;IACtD,yCAAyC,EAAE,cAAc;EAC3D;;EAEA;IACE,6BAA6B,EAAE,6BAA6B;EAC9D;AACF","sourcesContent":[".ProseMirror {\n  .tableWrapper {\n    margin-top: 3rem; /* my-12 */\n    margin-bottom: 3rem;\n  }\n\n  table {\n    border-collapse: collapse;\n    border: 1px solid rgba(0, 0, 0, 0.1); /* border-black/10 */\n    border-radius: 0.375rem; /* rounded */\n    box-sizing: border-box; /* box-border */\n    width: 100%; /* w-full */\n  }\n\n  td,\n  th {\n    border: 1px solid rgba(0, 0, 0, 0.1); /* border-black/10 */\n    min-width: 100px; /* min-w-[100px] */\n    padding: 0.5rem; /* p-2 */\n    position: relative;\n    text-align: left; /* text-left */\n    vertical-align: top; /* align-top */\n  }\n\n  td:first-of-type:not(a) {\n    margin-top: 0; /* mt-0 */\n  }\n\n  td p {\n    margin: 0; /* m-0 */\n  }\n\n  td p + p {\n    margin-top: 0.75rem; /* mt-3 */\n  }\n\n  th {\n    font-weight: bold; /* font-bold */\n  }\n\n  .column-resize-handle {\n    bottom: -2px; /* -bottom-[2px] */\n    display: flex;\n    pointer-events: none; /* pointer-events-none */\n    position: absolute;\n    right: -1px; /* -right-1 */\n    top: 0; /* top-0 */\n    width: 0.5rem; /* w-2 */\n  }\n\n  .column-resize-handle::before {\n    background-color: rgba(0, 0, 0, 0.2); /* bg-black/20 */\n    height: 100%; /* h-full */\n    width: 1px; /* w-[1px] */\n    margin-left: 0.5rem; /* ml-2 */\n    content: \"\";\n  }\n\n  .selectedCell {\n    background-color: rgba(0, 0, 0, 0.05); /* bg-black/5 */\n    border-color: rgba(0, 0, 0, 0.2); /* border-black/20 */\n    border-style: double; /* border-double */\n  }\n\n  .grip-column,\n  .grip-row {\n    align-items: center; /* items-center */\n    background-color: rgba(0, 0, 0, 0.05); /* bg-black/5 */\n    cursor: pointer; /* cursor-pointer */\n    display: flex;\n    justify-content: center; /* justify-center */\n    position: absolute;\n    z-index: 10; /* z-10 */\n  }\n\n  .grip-column {\n    width: calc(100% + 1px); /* w-[calc(100%+1px)] */\n    border-left: 1px solid rgba(0, 0, 0, 0.2); /* border-l border-black/20 */\n    height: 0.75rem; /* h-3 */\n    left: 0; /* left-0 */\n    margin-left: -1px; /* -ml-[1px] */\n    top: -0.75rem; /* -top-3 */\n  }\n\n  .grip-column:hover,\n  .grip-column.selected {\n    &::before {\n      content: \"\";\n      width: 0.625rem; /* w-2.5 */\n    }\n  }\n\n  .grip-column:hover {\n    background-color: rgba(0, 0, 0, 0.1); /* bg-black/10 */\n  }\n\n  .grip-column:hover::before {\n    border-bottom: 2px solid rgba(0, 0, 0, 0.6); /* border-b-2 border-dotted border-black/60 */\n  }\n\n  .grip-column.first {\n    border-color: transparent; /* border-transparent */\n    border-radius: 0.125rem 0 0 0; /* rounded-tl-sm */\n  }\n\n  .grip-column.last {\n    border-radius: 0 0.125rem 0 0; /* rounded-tr-sm */\n  }\n\n  .grip-column.selected {\n    background-color: rgba(0, 0, 0, 0.3); /* bg-black/30 */\n    border-color: rgba(0, 0, 0, 0.3); /* border-black/30 */\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15); /* shadow-sm */\n  }\n\n  .grip-column.selected::before {\n    border-bottom: 2px solid dotted; /* border-b-2 border-dotted */\n  }\n\n  .grip-row {\n    height: calc(100% + 1px); /* h-[calc(100%+1px)] */\n    border-top: 1px solid rgba(0, 0, 0, 0.2); /* border-t border-black/20 */\n    left: -0.75rem; /* -left-3 */\n    width: 0.75rem; /* w-3 */\n    top: 0; /* top-0 */\n    margin-top: -1px; /* -mt-[1px] */\n  }\n\n  .grip-row:hover,\n  .grip-row.selected {\n    &::before {\n      height: 0.625rem; /* h-2.5 */\n      content: \"\";\n    }\n  }\n\n  .grip-row:hover {\n    background-color: rgba(0, 0, 0, 0.1); /* bg-black/10 */\n  }\n\n  .grip-row:hover::before {\n    border-left: 2px solid dotted rgba(0, 0, 0, 0.6); /* border-l-2 border-dotted border-black/60 */\n  }\n\n  .grip-row.first {\n    border-color: transparent; /* border-transparent */\n    border-radius: 0.125rem 0 0 0; /* rounded-tl-sm */\n  }\n\n  .grip-row.last {\n    border-radius: 0 0.125rem 0 0; /* rounded-bl-sm */\n  }\n\n  .grip-row.selected {\n    background-color: rgba(0, 0, 0, 0.3); /* bg-black/30 */\n    border-color: rgba(0, 0, 0, 0.3); /* border-black/30 */\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15); /* shadow-sm */\n  }\n\n  .grip-row.selected::before {\n    border-left: 2px solid dotted; /* border-l-2 border-dotted */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
